import React from "react";

export const Header = () => {
  const handleButtonClick = (e) => {
    e.preventDefault();
    const contactSection = document.getElementById("contact");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6 col-md-offset-1 intro-text">
                <h1>
                  More than
                  <br />
                  Just a cake
                </h1>
                <p>
                  Custom-designed cakes and desserts
                  <br />
                  to impress and create memories.
                </p>
                <button
                  onClick={handleButtonClick}
                  className="btn btn-custom btn-lg"
                >
                  Turn your cake dream into reality
                </button>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
